import React from "react";
import styled from "styled-components";
import { BiLink, BiBuildings } from "react-icons/bi";
import { ImLocation, ImTwitter } from "react-icons/im";

const Card = styled.div`
  border-radius: 10px;
  background-color: ${(props) => props.theme["lm-bg-content"]};
  padding: 20px;
  margin-top: 20px;
  box-shadow: 0px 16px 30px -10px rgba(0, 0, 0, 0.2);
`;

const Image = styled.img`
  height: 80px;
  width: 80px;
  border-radius: 50%;

  @media only screen and (max-width: 768px) {
    height: 50px;
    width: 50px;
  }
`;

const CardHeaderWrapper = styled.section`
  display: flex;
  flex-direction: column;
`;

const CardHeader = styled.section`
  display: flex;
  justify-content: space-evenly;
`;

const UserName = styled.h1``;

const UserId = styled.h3`
  color: #60abff;
`;

const Bio = styled.p`
  margin-top: -25px;
  margin-left: 183px;

  @media only screen and (max-width: 768px) {
    margin-top: 30px;
    margin-left: 0;
  }
`;

const CardInfoWrapper = styled.div`
  display: flex;
  flex-direction: row;

  @media only screen and (max-width: 768px) {
    flex-direction: column;
  }
`;

const CardInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

const JoinedDate = styled.span`
  font-size: 16px;
  font-weight: 400;
  margin-left: 100px;

  @media only screen and (max-width: 768px) {
    margin-left: 0;
  }
`;

const UserStatsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-top: 30px;
  margin-left: 170px;
  padding: 10px;
  border-radius: 10px;
  background-color: ${(props) => props.theme["lm-bg"]};

  @media only screen and (max-width: 768px) {
    margin-left: 10px;
  }
`;

const UserStat = styled.div`
  display: flex;
  flex-direction: column;
`;

const ProfileBottom = styled.div`
  display: flex;
  flex-flow: column wrap;
  max-height: 70px;
  margin-left: 170px;
  margin-top: 50px;

  @media only screen and (max-width: 768px) {
    max-height: 150px;
    margin-left: 10px;
  }
`;

const ProfileInfo = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;

  @media only screen and (max-width: 768px) {
    margin-bottom: 5px;
  }
`;

const Info = styled.p`
  margin-left: 5px;
`;

const UserCard = ({ user }) => {
  return (
    <Card>
      <CardHeaderWrapper>
        <CardHeader>
          <Image src={user.avatar_url} />
          <CardInfoWrapper>
            <CardInfo>
              <UserName>{user.name}</UserName>
              <UserId>@{user.login}</UserId>
            </CardInfo>
            <JoinedDate>
              Joined{" "}
              {new Date(user?.created_at)
                .toLocaleDateString("en-GB", {
                  day: "numeric",
                  month: "short",
                  year: "numeric",
                })
                .replace(/ /g, " ")}
            </JoinedDate>
          </CardInfoWrapper>
        </CardHeader>
      </CardHeaderWrapper>
      <Bio>{user.bio ? user.bio : "This profile has no bio."}</Bio>
      <UserStatsContainer>
        <UserStat>
          <h4>Repos</h4>
          <h2>{user?.public_repos}</h2>
        </UserStat>
        <UserStat>
          <h4>Followers</h4>
          <h2>{user?.followers}</h2>
        </UserStat>
        <UserStat>
          <h4>Following</h4>
          <h2>{user?.following}</h2>
        </UserStat>
      </UserStatsContainer>
      <ProfileBottom>
        <ProfileInfo>
          <ImLocation />
          <Info>{user.location ? user.location : "Not available"}</Info>
        </ProfileInfo>
        <ProfileInfo>
          <BiLink />
          <Info>{user.blog ? user.blog : "Not available"}</Info>
        </ProfileInfo>
        <ProfileInfo>
          <ImTwitter />
          <Info>
            {user.twitter_username ? user.twitter_username : "Not available"}
          </Info>
        </ProfileInfo>
        <ProfileInfo>
          <BiBuildings />
          <Info>{user.company ? user.company : "Not available"}</Info>
        </ProfileInfo>
      </ProfileBottom>
    </Card>
  );
};

export default UserCard;
